import { PapiComment } from '@wix/da-papi-types';

export const isActionable = ({
  isOwner,
  isAuthor,
  isReportable,
  isSpam,
}: PapiComment): boolean => {
  return (isOwner || isAuthor || isReportable) && !isSpam;
};

export function canPeek(comment: PapiComment) {
  // $canPeek = ($is_admin_mode && ($is_hidden || $is_admin_hidden || $is_spam || $is_deleted)) // admin can see all
  //         || ($is_owner && (($is_hidden && !$is_admin_hidden) || $is_spam)) // owner can see owner-hidden or spam
  //         || ($is_author && $is_deleted); // author can see deleted

  if (comment.isOwner) {
    // owner can see owner-hidden
    if (comment.isHidden && !comment.isAdminHidden) {
      return true;
    }
    // and spam
    if (comment.isSpam) {
      return true;
    }
  }

  if (comment.isAuthor) {
    // comment author can see deleted
    if (comment.isDeleted) {
      return true;
    }
  }

  return false;
}

export function isCommentHidden(
  { isDeleted, isHidden, isAdminHidden, isSpam, replies }: PapiComment,
  isPeeking: boolean
) {
  // these rules match those in CommentBody
  const isVisible = !isAdminHidden && !isDeleted;

  if (!isPeeking && isSpam && replies !== 0) {
    return true;
  }

  if (!isPeeking && (isHidden || !isVisible) && replies !== 0) {
    return true;
  }

  if ((isHidden || !isVisible || isSpam) && !isPeeking) {
    return true;
  }

  return false;
}

export function getCommentNotificationQueue({ commentId }: PapiComment) {
  return `comment-${commentId}`;
}

export function generateReplyEditorId(comment: PapiComment): string {
  return `reply-${comment.commentId}`;
}
